import * as React from 'react';
import { useTranslate } from 'react-admin';
import CreateComponent from "../core/CreateComponent";
import TablesRestaurantCreateContent from './CreateContent';


const TablesRestaurantCreate = (props) => {
  const t = useTranslate();
  return (
    <CreateComponent
      title={t('QRCODE.TITLE_CREATE')}
      breadcrumb={t('QRCODE.TITLE_CREATE')}
      notifyname={t('QRCODE.NAME')}
      notifyitem="id_table"
      {...props}>
      <TablesRestaurantCreateContent />
    </CreateComponent>
  );
};

export default TablesRestaurantCreate;